import { render, staticRenderFns } from "./AddToBriefcaseButton.vue?vue&type=template&id=32b0a975&scoped=true"
import script from "./AddToBriefcaseButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddToBriefcaseButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0a975",
  null
  
)

export default component.exports